import styled from 'styled-components'

import { QuickBuyButton } from '@root/features/trade/swap/ui/desktop'
import { TableMakerCell } from '@root/features/trade/tables/table-cell/table-maker-cell'

import type { TrackedWalletSwapAlert } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type TrackingWalletFollowingUpdateCardHeaderProps = {
  trade: TrackedWalletSwapAlert.Alert
} & ClassNameProps

export const TrackingWalletFollowingUpdateCardHeader: React.FC<
  TrackingWalletFollowingUpdateCardHeaderProps
> = ({ className, trade }) => {
  return (
    <Root className={className}>
      <TableMakerCell
        pair={trade.pair}
        maker={trade.maker}
        network={trade.network}
        className={className}
        childrenPosition="end"
        color="var(--row-color)"
        pairAddress={trade.pairAddress}
      />
      {trade.pair ? (
        <QuickBuyButton
          withIcon
          pair={trade.pair}
          withAmount
          section="walletsTracker"
        />
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  height: 28px;
  justify-content: space-between;
`
